import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const getAllRemixerUsers = createAsyncThunk(
	"remixers/getAllRemixerUsers",
	async ({ token, ...queryParams }) => {
		const response = await api.get("/remixer-user", {
			token,
			params: queryParams,
		});
		return response.data;
	}
);

export const getRemixerUserById = createAsyncThunk(
	"remixers/getRemixerUserById",
	async ({ token, id }) => {
		const response = await api.get(`/remixer-user/${id}`, { token });
		return response.data;
	}
);

export const createRemixerUser = createAsyncThunk(
	"remixers/createRemixer",
	async ({ token, payload }) => {
		const response = await api.post(
			"/remixer-user",
			{ ...payload },
			{ token }
		);
		return response.data;
	}
);

export const updateRemixerUser = createAsyncThunk(
	"remixers/updateRemixer",
	async ({ token, id, ...updateData }) => {
		const response = await api.patch(`/remixer-user/${id}`, updateData, {
			token,
		});
		return response.data;
	}
);

export const suspendRemixerUser = createAsyncThunk(
	"remixers/suspendRemixer",
	async ({ token, id }) => {
		const response = await api.patch(
			`/remixer-user/suspend/${id}`,
			{},
			{ token }
		);
		return response.data;
	}
);

export const activateRemixerUser = createAsyncThunk(
	"remixers/activateRemixer",
	async ({ token, id }) => {
		const response = await api.patch(
			`/remixer-user/activate/${id}`,
			{},
			{ token }
		);
		return response.data;
	}
);

export const deleteRemixerUser = createAsyncThunk(
	"remixers/deleteRemixer",
	async ({ token, id }) => {
		const response = await api.delete(`/remixer-user/${id}`, { token });
		return response.data;
	}
);

export const getRemixerProfiles = createAsyncThunk(
	"remixers/getRemixerProfiles",
	async ({ token, ...queryParams }) => {
		const response = await api.get("/remixer-user/profiles", {
			token,
			params: queryParams,
		});
		return response.data;
	}
);

// NOTE: Validating the generated authenticaion token for password reset
export const validateToken = createAsyncThunk(
	"remixers/validate/token",
	async ({ id, token }) => {
		const response = await api.get(
			`/remixer-user/verify-set-password/${id}/${token}`
		);
		return response.data;
	}
);

export const setPassword = createAsyncThunk(
	"remixers/password",
	async ({ id, token, data }) => {
		const response = await api.patch(
			`/remixer-user/set-password/${id}/${token}`,
			data
		);
		return response.data;
	}
);

export const getRemixerUserTracks = createAsyncThunk(
	"remixers/getRemixerUserTracks",
	async ({ token, id, ...queryParams }) => {
		const response = await api.get(`/remixer-user/${id}/tracks`, {
			token,
			params: queryParams,
		});
		return response.data;
	}
);

export const getRemixerUserEarnings = createAsyncThunk(
	"remixers/getRemixerUserEarnings",
	async ({ token, id, ...queryParams }) => {
		const response = await api.get(`/remixer-user/${id}/earnings`, {
			token,
			params: queryParams,
		});
		return response.data;
	}
);

export const getRemixerUploadedTracks = createAsyncThunk(
	"remixers/getRemixerUploadedTracks",
	async ({ token, id, ...queryParams }) => {
		const response = await api.get(`/remixers/downloads/${id}`, {
			token,
			params: queryParams,
		});
		return response.data;
	}
);

export const getRemixerEarningsDetails = createAsyncThunk(
	"remixers/getRemixerEarningsDetails",
	async ({ token, id, ...queryParams }) => {
		const response = await api.get(`/remixers/earnings/${id}`, {
			token,
			params: queryParams,
		});
		return response.data;
	}
);

export const getRemixerEarningsSummary = createAsyncThunk(
	"remixers/getRemixerEarningsSummary",
	async ({ token, id, ...queryParams }) => {
		const response = await api.get(`/remixers/earnings-summary/${id}`, {
			token,
			params: queryParams,
		});
		return response.data;
	}
);

export const updateFeaturedRemixers = createAsyncThunk(
  "remixer/updateFeatured",
  async ({ token, featuredRanks }) => {
    const response = await api.put(
      `/remixer-user/featured`,
      { featuredRanks },
      { token }
    );
    return response.data;
  }
);